import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\CreateInvoiceForEnaosItemController::__invoke
* @see app/Http/Controllers/Dossier/CreateInvoiceForEnaosItemController.php
* @route '/api/dossier/{dossier}/enaos-item-invoice'
*/
const CreateInvoiceForEnaosItemController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoiceForEnaosItemController.url(args, options),
    method: 'post',
})

CreateInvoiceForEnaosItemController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/enaos-item-invoice',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\CreateInvoiceForEnaosItemController::__invoke
* @see app/Http/Controllers/Dossier/CreateInvoiceForEnaosItemController.php
* @route '/api/dossier/{dossier}/enaos-item-invoice'
*/
CreateInvoiceForEnaosItemController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return CreateInvoiceForEnaosItemController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\CreateInvoiceForEnaosItemController::__invoke
* @see app/Http/Controllers/Dossier/CreateInvoiceForEnaosItemController.php
* @route '/api/dossier/{dossier}/enaos-item-invoice'
*/
CreateInvoiceForEnaosItemController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoiceForEnaosItemController.url(args, options),
    method: 'post',
})

export default CreateInvoiceForEnaosItemController